import { Component } from '@angular/core';

@Component({
    selector: 'not-allowed',
    templateUrl: './not-allowed.component.html',
    styleUrls: ['./not-allowed.component.scss'],
    standalone: false
})
export class NotAllowedComponent {

}
